import { Field, ImageField, LinkField, TextField } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from '@gn-audio/jss-components/lib/component-props';

export type IntroSectionItemProps = {
  title: TextField;
  icon: ImageField;
  link: LinkField;
  iconDropList: Field<string>;
  id: string;
};
export type IntroSectionFields = {
  eyebrowText: TextField;
  title: TextField;
  description: TextField;
  items: IntroSectionItemProps[];
  dataSource: {
    Title: Field<string>;
    Header: Field<string>;
    Text: Field<string>;
  };
  dataSourceShared: {
    Title: Field<string>;
    Header: Field<string>;
    Text: Field<string>;
  };
};
export type IntroSectionProps = {
  fields: IntroSectionFields;
} & ComponentProps;
